import Variable from '../../constants/constants.json';

const { createRequest } = require('../../api/client');

export const getUserAdoptionData = (data) => {
    const options = {
        url: `${Variable.backendUrl}/userAdoption/insights`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        qs: data,
    };

    return createRequest(options);
};